import { rawToFaq } from '../rawMappers/faq';
import { rawToItemListing } from '../rawMappers/itemListing';
import { nonNullable } from '../utils';
import { faqMapper } from './faq';
import { itemListingMapper } from './itemListing';
import { OrganizationMapperResult } from './organization';

export const bodyMapper = (
  body: Record<string, null | unknown>[],
  organization: OrganizationMapperResult
) => {
  const mapping = {
    accordion: [rawToFaq, faqMapper],
    itemListing: [rawToItemListing, itemListingMapper],
  };

  return body
    .map((item) =>
      Object.entries(item).find(
        ([key, value]) => value !== null && mapping[key]
      )
    )
    .filter(nonNullable)
    .map(([key, data]) => {
      const [rawMapper, structuredDataMapper] = mapping[key];

      const mappedData = rawMapper(data, organization);

      if (mappedData === null) {
        return null;
      }

      return structuredDataMapper(mappedData, organization);
    })
    .filter(nonNullable);
};
